const SPECS: { label: string; value: string }[] = [
  { label: "Technologia", value: "Doming – zalewanie nadruku dwuskładnikową żywicą poliuretanową" },
  { label: "Wysokość wypukłości", value: "około 2 mm" },
  { label: "Minimalny rozmiar naklejki", value: "5 × 5 mm" },
  { label: "Maksymalny rozmiar naklejki", value: "380 × 280 mm" },
  { label: "Kształty", value: "prostokąt, kwadrat, koło, owal oraz kształt po obrysie (wycena indywidualna)" },
  { label: "Rodzaje folii", value: "14 materiałów: białe, przezroczyste, chromy, maty, holograficzne, odblaskowa" },
  { label: "Trwałość", value: "do 15 lat – żywica jest odporna na UV, wodę i mycie" },
  { label: "Zastosowanie", value: "wnętrze i zewnątrz, powierzchnie płaskie i lekko wypukłe" },
  { label: "Minimalna wartość zamówienia", value: "100 zł netto" },
  { label: "Sugerowany minimalny nakład", value: "50 szt." },
  { label: "Termin realizacji", value: "3–7 dni roboczych od akceptacji projektu" },
  { label: "Wysyłka", value: "Polska i Unia Europejska, kurier 18 zł netto" },
  { label: "Pliki do druku", value: "wektor PDF, AI, EPS, CDR, SVG – teksty w krzywych" },
  { label: "Odporność temperaturowa", value: "[DO UZUPEŁNIENIA: zakres temperatur pracy naklejek]" },
  { label: "Tolerancja wymiarowa", value: "[DO UZUPEŁNIENIA: tolerancja wycinania w mm]" },
];

/** Technical specification table – helps both B2B buyers and AI search engines. */
const SpecTable = () => (
  <section id="specyfikacja" className="py-12 md:py-20">
    <div className="container mx-auto px-4 max-w-4xl">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
        Specyfikacja techniczna naklejek wypukłych 3D
      </h2>
      <p className="text-muted-foreground mb-6 md:mb-8 leading-relaxed">
        Parametry produkcyjne, które najczęściej potrzebne są działom zakupów i marketingu
        przy zamówieniu naklejek domingowych.
      </p>
      <div className="overflow-x-auto rounded-2xl border border-border">
        <table className="w-full text-sm">
          <caption className="sr-only">Parametry techniczne naklejek 3D zalewanych żywicą</caption>
          <tbody>
            {SPECS.map((s, i) => (
              <tr key={s.label} className={i % 2 ? "bg-secondary/40" : "bg-card"}>
                <th scope="row" className="text-left font-semibold text-foreground p-3 md:p-4 w-2/5 align-top">
                  {s.label}
                </th>
                <td className="p-3 md:p-4 text-muted-foreground align-top">{s.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default SpecTable;
